/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function () {
  'use strict';
  var TlpsTraslocoDefinizioneProdottoCtrl = function (
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    traslocoTelepassSrvc,
    uiGridConstants,
    userSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.gridApi = null;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.traslocoTelepassSrvc = traslocoTelepassSrvc;

    // Spinner
    this.spinner = this.traslocoTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;
    // Conto selezionato dall'utente per proseguire la pratica
    this.contoSelezionato = undefined;

    // Opzioni della tabella dei conti
    this.gridOptions = {};
    this.tableHeight = 0;
    this.contiCorrenti = [];

    this.codiceCliente;
    this.codiceApparato;

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name selezionaConto
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaConto = function (conto) {
      if (
        self.traslocoTelepassSrvc.datiPratica.numeroRapporto !==
        conto.entity.numeroRapporto
      ) {
        self.traslocoTelepassSrvc.datiPratica.numeroRapporto =
          conto.entity.numeroRapporto;
      } else {
        self.traslocoTelepassSrvc.datiPratica.numeroRapporto = null;
      }
    };

    /*
     * -------------------------------------
     *          GESTIONE BOTTONI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Verifica che i campi obbligatori siano valorizzati correttamente.
     */
    this.traslocoTelepassSrvc.datiValidi = function () {
      //Controlla che un conto sia stato selezionato
      var valid = true;

      if (!self.traslocoTelepassSrvc.datiPratica.numeroRapporto) {
        valid = false;
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un conto';
        messaggiFctr.addMessage(message);
      }

      if (!self.traslocoTelepassSrvc.datiPratica.codiceContrattoTrasloco) {
        valid = false;
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un codice cliente';
        messaggiFctr.addMessage(message);
      }

      if (!self.traslocoTelepassSrvc.datiPratica.codiceApparato) {
        valid = false;
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un codice apparato';
        messaggiFctr.addMessage(message);
      }

      return valid;
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */
    this.init = function () {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;

      self.spinner.showSpinner = true;
      self.traslocoTelepassSrvc
        .promiseRecuperaContiCorrenti(self.ndg)
        .then(
          function (response) {
            if (self.messaggiFctr.processaResponse(response)) {
              self.spinner.showSpinner = false;
              return;
            }

            self.contiCorrenti = response.data.result;
            self.tableHeight = response.data.result.length * 30 + 40;

            for (var i in self.contiCorrenti) {
              self.contiCorrenti[
                i
              ].dataApertura = self.traslocoTelepassSrvc.formattazioneData(
                self.contiCorrenti[i].dataApertura
              );
            }
            // // Configurazione tabella
            self.gridOptions = {
              enableSorting: true,
              enableColumnMenus: false,
              enableGrouping: false,
              multiSelect: false,
              showHeader: true,
              enableRowHeaderSelection: false,
              enableRowSelection: !self.traslocoTelepassSrvc.isPraticaNavigabile(),
              showGridFooter: false,
              enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
              enableColumnResizing: true,
              columnDefs: [
                {
                  displayName: 'Numero Rapporto',
                  field: 'numeroRapporto',
                  width: '10%',
                  name: 'numeroRapporto'
                },
                {
                  displayName: 'Iban',
                  field: 'iban',
                  width: '25%',
                  name: 'iban'
                },
                {
                  displayName: 'Descrizione',
                  field: 'descrizione',
                  width: '15%',
                  name: 'descrizione'
                },
                {
                  displayName: 'Saldo Contabile',
                  cellFilter: 'number : 2',
                  cellClass: 'right',
                  field: 'saldoContabile',
                  width: '10%',
                  name: 'saldoContabile'
                },
                {
                  displayName: 'Intestatario',
                  cellClass: 'right',
                  field: 'intestazione',
                  width: '20%',
                  name: 'intestazione'
                },
                {
                  displayName: 'Stato',
                  field: 'stato',
                  width: '10%',
                  name: 'stato'
                },
                {
                  displayName: 'Data Apertura',
                  field: 'dataApertura',
                  cellFilter: 'date: "dd/MM/yyyy"',
                  width: '10%',
                  name: 'dataApertura'
                }
              ],
              data: self.contiCorrenti,
              onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                self.gridApi.grid.modifyRows(self.gridOptions.data);

                // Se era già stato salvato il conto corrente lo recupero e lo seleziono
                if (
                  self.traslocoTelepassSrvc.datiPratica &&
                  self.traslocoTelepassSrvc.datiPratica.numeroRapporto
                ) {
                  angular.forEach(self.contiCorrenti, function (conto, index) {
                    if (
                      conto.numeroRapporto ===
                      self.traslocoTelepassSrvc.datiPratica.numeroRapporto
                    ) {
                      self.gridApi.selection.selectRow(
                        self.contiCorrenti[index]
                      );
                      self.contoSelezionato = self.contiCorrenti[index];
                    }
                  });
                }

                gridApi.selection.on.rowSelectionChanged($scope, function (row) {
                  self.selezionaConto(row);
                });
              }
            };
          },
          function (reason) {
            if (self.messaggiFctr.processaResponse(reason)) {
              self.spinner.showSpinner = false;
            }
          }
        )
        .finally(function () {
          self.spinner.showSpinner = false;
        });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  TlpsTraslocoDefinizioneProdottoCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsTraslocoTelepassSrvc',
    'uiGridConstants',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDettaglioProdotto/tlpsTraslocoDettaglioProdotto.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var TlpsTraslocoDefinizioneProdottoComponent = {
    bindings: {},
    controller: TlpsTraslocoDefinizioneProdottoCtrl,
    controllerAs: 'traslocoDefinizioneProdottoCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component(
      'tlpsTraslocoDefinizioneProdotto',
      TlpsTraslocoDefinizioneProdottoComponent
    );
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsPostVendita/tlpsTraslocoTelepass/tlpsTraslocoDefinizione/tlpsTraslocoDettaglioProdotto/tlpsTraslocoDettaglioProdotto.cmpt.js
// module id = 24
// module chunks = 0